<template>
  <v-row
    no-gutters
    align="center"
  >
    <slot name="title">
      <div
        class="py-0 px-0 pt-md-4 pb-md-6 px-md-0 text-h6"
      >
        {{ title }}
      </div>
    </slot>

    <v-spacer />

    <slot name="actions" />
  </v-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

<style>

</style>
